"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetTrafficOutputs($filter: TrafficOutputFilterInput, $limit: Int, $offset: Int) {\n    getTrafficOutputs(filter: $filter, limit: $limit, offset: $offset) {\n      count\n      outputs {\n        name\n        outputId\n        readableId\n        videoId\n        status {\n          name\n        }\n        aspectRatio\n        difficulty\n        assignedEditorId\n        isMaster\n        onHoldDate\n        onHoldReason\n        editor {\n          userId\n          firstName\n          lastName\n          imageUrl\n        }\n        latestVersion\n        versions {\n          versionId\n          versionNumber\n          submittedAt\n          dueDate\n          assetId\n          appliedAddons {\n            BURN_IN_CAPTIONS {\n              value\n            }\n            SRT_CAPTIONS {\n              value\n            }\n            GREEN_SCREEN {\n              status\n            }\n            CHROMA_KEY {\n              value\n            }\n            RUSH_EDIT {\n              value\n            }\n            DURATION {\n              value\n            }\n          }\n          requestedAddons {\n            BURN_IN_CAPTIONS {\n              value\n            }\n            SRT_CAPTIONS {\n              value\n            }\n            GREEN_SCREEN {\n              status\n            }\n            CHROMA_KEY {\n              status\n            }\n            RUSH_EDIT {\n              value\n            }\n            DURATION {\n              value\n            }\n          }\n        }\n        video {\n          name\n          videoId\n          submittedAt\n          organisation {\n            organisationId\n            atRisk\n            name\n            alias\n          },\n          creator {\n            userId\n            firstName\n            lastName\n            imageUrl\n            email\n          }\n          owner {\n            userId\n            firstName\n            lastName\n            imageUrl\n            email\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getTrafficOutputsQuery = (0, _graphqlTag.default)(_templateObject());
var getTrafficOutputs = {
  query: getTrafficOutputsQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: function buildVariables(input) {
    var limit = input.limit,
        offset = input.offset,
        rest = _objectWithoutProperties(input, ["limit", "offset"]);

    return {
      filter: _objectSpread({}, rest),
      limit: limit,
      offset: offset
    };
  }
};
var _default = getTrafficOutputs;
exports.default = _default;